import Tag from "components/Tag";
import { ScanText } from "lucide-react";
import React from "react";
import { PaperQuote } from "store/slices/citedPapers";

interface QuoteSelectorProps {
  quotes: PaperQuote[];
  selectedQuote?: number;
  onSelectQuote: (index: number) => void;
  citation?: number;
  className?: string;
}

/**
 * QuoteSelector - Core component that renders selectable quote/excerpt tags
 * Extracted from SearchResult for reusability across components
 */
export const QuoteSelector: React.FC<QuoteSelectorProps> = ({
  quotes,
  selectedQuote,
  onSelectQuote,
  citation,
  className = "",
}) => {
  if (!quotes || quotes.length === 0) {
    return null;
  }

  return (
    <div className={`flex gap-2 ${className}`}>
      {quotes.map((quote, index) => (
        <Tag
          key={`${citation ? `${citation}.` : ""}${quote.quoteIndex + 1}`}
          label={`${citation ? `${citation}.` : ""}${quote.quoteIndex + 1}`}
          icon={<ScanText size={12} />}
          size="sm"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSelectQuote(index);
          }}
          selected={selectedQuote === index}
        />
      ))}
    </div>
  );
};

export default QuoteSelector;
